import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import SatelliteVisibilityWidget from './SatelliteVisibilityWidget.vue';
import KPIndexWidget from './KPIndexWidget.vue';
import WeatherWidget from './WeatherWidget.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupplementaryData',
  setup(__props) {

const currentItem = ref('tab-satvis');

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_tabs, {
      grow: "",
      modelValue: currentItem.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentItem).value = $event)),
      "hide-slider": ""
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_v_tab, { value: "tab-satvis" }, {
          default: _withCtx(() => [
            _createTextVNode("GPS Sat. Visibility")
          ]),
          _: 1
        })), [
          [_directive_ripple, false]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_v_tab, { value: "tab-weather" }, {
          default: _withCtx(() => [
            _createTextVNode("Weather Forecast")
          ]),
          _: 1
        })), [
          [_directive_ripple, false]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_v_tab, { value: "tab-kpi" }, {
          default: _withCtx(() => [
            _createTextVNode("KP Index")
          ]),
          _: 1
        })), [
          [_directive_ripple, false]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: currentItem.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentItem).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "tab-satvis" }, {
          default: _withCtx(() => [
            _createVNode(SatelliteVisibilityWidget)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "tab-weather" }, {
          default: _withCtx(() => [
            _createVNode(WeatherWidget)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "tab-kpi" }, {
          default: _withCtx(() => [
            _createVNode(KPIndexWidget)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})